<template>
    <ModalTheme :with-content="true" @close="closeModal" :theme="true" :fix-height="false">
        <template slot="main">
            <loader :loading="true" v-if="loading"></loader>
            <div id="example-3">
                <ClientColorButton size="xs" @click="checkIdsList = [];">{{ $t("checkBoxModal.selectNone") }}</ClientColorButton>
                <ClientColorButton size="xs" @click="checkIdsList = list.map(l => l.id);">{{ $t("checkBoxModal.selectAll") }}</ClientColorButton>
                <br /><br />
                <div v-for="element in list">
                    <input type="checkbox" :id="element.id" :value="element.id" v-model="checkIdsList" />
                    <label :for="element.id">{{ element.name | capitalize }} </label>
                </div>
            </div>
            <br />
            <ClientColorButton
                @click="
                    $emit('submit', checkIdsList);
                    $emit('closed');
                "
                >{{ this.buttonName }}</ClientColorButton
            >
        </template>
    </ModalTheme>
</template>

<script>
import ModalTheme from "@/components/ui/ModalTheme";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import { mapActions } from "vuex";

export default {
    components: { ModalTheme, loader },
    props: ["list", "buttonName"],
    mixins: [TryLoad],
    data() {
        return {
            checkIdsList: []
        };
    },
    methods: {
        closeModal() {
            this.$emit("closed");
        }
    }
};
</script>



// WEBPACK FOOTER //
// CheckBoxModal.vue?10186d16